module.exports = __webpack_public_path__ + "img/googlereviewsp6.6bf03da7.png";